import { render } from "./catalog.vue?vue&type=template&id=23624a0a&scoped=true"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"

import "./catalog.vue?vue&type=style&index=0&id=23624a0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23624a0a"

export default script